import { readRecord, readString } from '../readers';
import { requestHasStatus } from '../requestError';
import { semanticPost } from '../semanticRepository';
import type { DataRequest, DataRequestReceipt } from './model';
import { m } from '../../paraglide/messages';

const readDataRequestReceipt = (value: unknown): DataRequestReceipt => ({
  id: readString(readRecord(value, 'data request receipt').id, 'data request id'),
});

/**
 * Posts one data request to the gateway's web feedback route.
 *
 * The transport attaches the Clerk token whenever a session is bound, so the
 * same call is anonymous on a marketing page and attributed to the customer in
 * the dashboard. Nothing about the sender is assembled here: the gateway reads
 * identity from the credential rather than from anything the browser claims.
 */
export const submitDataRequest = (request: DataRequest): Promise<DataRequestReceipt> =>
  semanticPost(
    '/public/feedback',
    {
      summary: request.message,
      sku: request.sku ?? '',
      page: request.page,
      contact: request.contact ?? '',
    },
    readDataRequestReceipt,
  );

/** Turns a failed submission into one line a sender can act on. */
export const dataRequestErrorMessage = (error: unknown): string => {
  if (requestHasStatus(error, 429)) return m.phase2_fix_feedback_rate_limited();
  return m.phase2_fix_feedback_send_failed();
};
